export interface IColor {
  hex: string;
  rgb: [number, number, number];
}
export class ColorUtil {
  private static colorRange(min: number, max: number): Function {
    return () => {};
  }

  private static componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  public static DEFAULT_COLOR: IColor = {
    hex: "#DCDCDC",
    rgb: [220, 220, 220],
  };

  public static DISCRETE_COLORS_RGB: Array<[number, number, number]> = [
    [44, 160, 44],
    [214, 39, 40],
    [148, 103, 189],
    [140, 86, 75],
    [196, 156, 148],
    [188, 189, 34],
    [219, 219, 141],
    [23, 190, 207],
    [158, 218, 229],
    [227, 119, 194],
    [247, 182, 210],
    [127, 127, 127],
    [199, 199, 199],
    [255, 127, 14],
    [255, 187, 120],
    [31, 119, 180],
    [174, 199, 232],

    [152, 223, 138],
    [255, 152, 150],
    [197, 176, 213],

    [163, 179, 64],
    [93, 57, 140],
    [99, 194, 111],
    [202, 115, 198],
    [70, 181, 124],
    [176, 69, 123],
    [61, 217, 205],
    [186, 71, 88],
    [31, 225, 251],
    [184, 82, 56],
    [68, 191, 153],
    [108, 128, 217],
    [203, 133, 48],
    [95, 137, 57],
    [170, 139, 66],
    // Crazy Color Pallet
    [1, 0, 103],
    [213, 255, 0],
    [255, 0, 86],
    [158, 0, 142],
    [14, 76, 161],
    [255, 229, 2],
    [0, 95, 57],
    [0, 255, 0],
    [149, 0, 58],
    [255, 147, 126],
    [164, 36, 0],
    [0, 21, 68],
    [145, 208, 203],
    [98, 14, 0],
    [107, 104, 130],
    [0, 0, 255],
    [0, 125, 181],
    [106, 130, 108],
    [0, 174, 126],
    [194, 140, 159],
    [190, 153, 112],
    [0, 143, 156],
    [95, 173, 78],
    [255, 0, 0],
    [255, 0, 246],
    [255, 2, 157],
    [104, 61, 59],
    [255, 116, 163],
    [150, 138, 232],
    [152, 255, 82],
    [167, 87, 64],
    [1, 255, 254],
    [255, 238, 232],
    [254, 137, 0],
    [189, 198, 255],
    [1, 208, 255],
    [187, 136, 0],
    [117, 68, 177],
    [165, 255, 210],
    [255, 166, 254],
    [119, 77, 0],
    [122, 71, 130],
    [38, 52, 0],
    [0, 71, 84],
    [67, 0, 44],
    [181, 0, 255],
    [255, 177, 103],
    [255, 219, 102],
    [144, 251, 146],
    [126, 45, 210],
    [189, 211, 147],
    [229, 111, 254],
    [222, 255, 116],
    [0, 255, 120],
    [0, 155, 255],
    [0, 100, 1],
    [0, 118, 255],
    [133, 169, 0],
    [0, 185, 23],
    [120, 130, 49],
    [0, 255, 198],
    [255, 110, 65],
    [232, 94, 190],
  ];

  public static DISCRETE_COLORS: Array<
    IColor
  > = ColorUtil.DISCRETE_COLORS_RGB.map((v: Array<number>) => ({
    rgb: [v[0], v[1], v[2]],
    hex: ColorUtil.rgbToHex(v[0], v[1], v[2]),
  }));

  static hexToColor(hex: string): IColor {
    return (
      this.DISCRETE_COLORS.find((v: IColor) => v.hex === hex) ||
      this.DEFAULT_COLOR
    );
  }
  static rgbToHex(r: number, g: number, b: number) {
    return (
      "#" +
      ColorUtil.componentToHex(r) +
      ColorUtil.componentToHex(g) +
      ColorUtil.componentToHex(b)
    );
  }

  static discreteFromIndex(index: number): IColor {
    return index < ColorUtil.DISCRETE_COLORS.length
      ? ColorUtil.DISCRETE_COLORS[index]
      : this.DEFAULT_COLOR;
  }
}
